var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/navigation/Link.tsx";
import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Styled component for a link (`<a>` element).
 */
const Link = function Link({
  children,
  classes,
  elementRef,
  underline = 'none',
  color,
  unstyled = false,
  variant = 'brand',
  ...htmlAttributes
}) {
  // Map from deprecated `color` prop to `variant` if `color` is present
  const theme = typeof color === 'string' ? color : variant;
  const styled = !unstyled;
  const themed = styled && theme !== 'custom';
  return _jsxDEV("a", {
    "data-component": "Link",
    rel: "noopener noreferrer",
    ...htmlAttributes,
    className: classnames(styled && {
      'focus-visible-ring rounded': true,
      // underline
      // TODO: Underline should be controlled by `variant` and should default
      // to `always`
      'no-underline hover:no-underline': underline === 'none',
      // default
      'underline hover:underline': underline === 'always',
      'no-underline hover:underline': underline === 'hover'
    }, themed && {
      // color
      'text-brand hover:text-brand-dark': theme === 'brand',
      // default
      'text-color-text-light hover:text-brand': theme === 'text-light',
      'text-color-text hover:text-brand-dark': theme === 'text'
    }, classes),
    ref: downcastRef(elementRef),
    children: children
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 43,
    columnNumber: 5
  }, this);
};
export default Link;
//# sourceMappingURL=Link.js.map